import {NgClass, NgStyle} from '@angular/common';
import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

import {FonteIconeComponent} from '../fonte-icone/fonte-icone.component';
import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {LibelleDicoPipe} from '../Utilitaires/libelle-dico.pipe';
import {ValBarreNavigationItem} from './DonneesBarreNavigation';
import {BarreNavigationComponent} from './barre-navigation.component';

//Composant barre de navigation item
@Component (
{
  selector: 'val-barre-navigation-item',
  imports: 
  [
    NgClass,
    NgStyle,
    FonteIconeComponent,
    SimpleLibelleComponent,
    LibelleDicoPipe
  ],
  templateUrl: './barre-navigation-item.component.html',
  styleUrl: './barre-navigation-item.component.scss'
})
export class BarreNavigationItemComponent implements OnInit, AfterViewInit 
{
  //Création
  constructor () 
  {
    this.groupe = false;
    this.ouvert = false;
    this.donneesItemGroupe = null;
    this.itemGroupe = null;
    this.popUpVisible = false;
  }

  //PopUp commandes
  @ViewChild ("popUp")
  public popUp!: ElementRef;

  //Données de l’item
  @Input ()
  public donneesItem!: ValBarreNavigationItem;

  //Données de l’item contenant
  @Input ()
  public donneesItemGroupe!: ValBarreNavigationItem | null;

  //Conteneur
  @Input ()
  public itemGroupe!: BarreNavigationItemComponent | null;

  //Barre de navigation
  @Input ()
  public barreNavigation!: BarreNavigationComponent;

  //Indique si l’item contient des commandes
  public groupe: boolean;

  //Indique si le groupe est ouvert
  public ouvert: boolean;

  //Indique si le popup des commandes est visible
  public popUpVisible: boolean;

  //Initialise le composant
  public ngOnInit () : void 
  {
    this.groupe = (this.donneesItem.commandes && this.donneesItem.commandes.length > 0) || false;
  }

  //Initialisation après la création de la vue
  public ngAfterViewInit () : void 
  {
    this.popUp.nativeElement.style.display = "none";
  }

  //Traite le click sur l’entête
  public EnteteClick () : void 
  {
    if (this.groupe)
      this.barreNavigation.OuvrirFermerGroupe (this.donneesItem);
    else
    {
      this.barreNavigation.CommandeClick (this.donneesItemGroupe, this.donneesItem);

      if (this.itemGroupe)
        this.itemGroupe.PopUpMouseLeave ();
    }
  }

  //Traite l’entrée de la souris sur l’entête
  public MouseEnter () : void 
  {
    if (this.groupe && !this.barreNavigation.ouvert)
      this.ChangerVisibilitePopUp (true);
  }

  //Traite la sortie de la souris de l’entête
  public MouseLeave () : void 
  {
    if (this.groupe && !this.barreNavigation.ouvert)
      this.ChangerVisibilitePopUp (false);
  }

  //Change la visibilité de la popup des commandes
  //  Paramètres
  //    visible : Indique si visible
  public ChangerVisibilitePopUp (visible: boolean) : void 
  {
    let popUpRect: DOMRect;
    let bodyRect: DOMRect;

    this.popUpVisible = visible;
      
    if (visible)
    {
      this.popUp.nativeElement.style.pointer_events = "all";
      this.popUp.nativeElement.style.display = "";

      popUpRect = this.popUp.nativeElement.getBoundingClientRect ();
      bodyRect = document.body.getBoundingClientRect ();

      if (popUpRect.bottom > bodyRect.bottom)
        this.popUp.nativeElement.style.bottom = "0px";
      else
        this.popUp.nativeElement.style.bottom = "";
    }
    else
    {
      this.popUp.nativeElement.style.pointer_events = "none";
      this.popUp.nativeElement.style.display = "none";
      this.popUp.nativeElement.style.bottom = "";
    }
  }

  //Traite l’entrée de la souris sur la popup des commandes
  public PopUpMouseEnter () : void 
  {
    this.ChangerVisibilitePopUp (true);
  }

  //Traite la sortie de la souris de la popup des commandes
  public PopUpMouseLeave () : void 
  {
    this.ChangerVisibilitePopUp (false);
  }
}
